import React from "react";
import {HiOutlineAtSymbol, HiOutlinePaperAirplane, HiOutlineStopCircle} from "react-icons/hi2";
import DelayedFadeIn from "../../DelayedFadeIn";
import MentionTextarea from "./MentionTextarea";
import {useSelector} from "react-redux";
import {ChatMentionTextAreaProps} from "../types";
import ChangeLLMModel from "./ChangeLLMModel";

const NewChatMentionTextArea: React.FC<ChatMentionTextAreaProps> = ({
  currentChat,
  inputText,
  inputTextRef,
  atButtonRef,
  mentions,
  onSubmit,
  onKeyDown,
  onMentionInputChange,
  onStopMessage,
  onAtBtnClick,
}) => {
  const {
    showBigChatbox,
    isChatbotSidebarCollapsed
  } = useSelector((state: any) => state.chatMessages);

  const {
    isLLMSettingsLoading
  } = useSelector((state: any) => state.settings);

  return (
    <DelayedFadeIn delay={300} className={`flex ${!showBigChatbox ? 'h-[140px]' : ''}`}>
      <div
        className={`
          ${!showBigChatbox ? 'absolute bottom-0 left-0 right-0 z-20 w-full p-4' : 'relative'}
          ${showBigChatbox && isChatbotSidebarCollapsed ? 'px-4 py-2 max-w-[65%] min-w-[65%] mx-auto' : ''}
          ${showBigChatbox && !isChatbotSidebarCollapsed ? 'px-4 py-2 max-w-[85%] min-w-[85%] mx-auto' : ''}
        `}
      >
        <form
          className={`chat-input relative`}
          data-onboarding="chat-input-area"
          onSubmit={onSubmit}
        >
          <MentionTextarea
            placeholder="Ask me anything…"
            value={inputText}
            onChange={onMentionInputChange}
            onKeyDown={onKeyDown}
            inputRef={inputTextRef}
            mentions={mentions}
            wrapperClassName="pb-6 sm:pb-8"
            className="block w-full mb-3 sm:mb-4 px-1 py-1.5 sm:py-2 text-[13px] sm:text-[15px] text-gray-900 dark:text-gray-100 bg-transparent focus:ring-0 focus:outline-none resize-none placeholder-gray-500 dark:placeholder-gray-400 border-b border-gray-200 dark:border-gray-700"
          />

          {/* Left action area: @ button + model pill */}
          <div className="absolute bottom-[10px] left-[10px] flex items-center gap-2">
            <button
              ref={atButtonRef}
              type="button"
              onClick={onAtBtnClick}
              className="w-8 h-8 border border-gray-300 dark:border-gray-600 rounded-xl hover:bg-gray-200 dark:hover:bg-gray-700 text-gray-700 dark:text-gray-200 flex items-center justify-center transition-colors duration-200"
              title="Insert mention (@)"
            >
              <HiOutlineAtSymbol className="w-3 h-3 sm:w-4 sm:h-4" />
            </button>

            <ChangeLLMModel />
          </div>

          {currentChat?.isStreaming && (
            <button
              type="button"
              onClick={onStopMessage}
              className="absolute bottom-[10px] right-[10px] w-8 h-8   rounded-xl hover:bg-gray-200 dark:hover:bg-gray-700 text-gray-700 dark:text-gray-200 flex items-center justify-center transition-colors duration-200"
              title="Stop generation"
            >
              <HiOutlineStopCircle className="w-7 h-7" />
            </button>
          )}

          {!currentChat?.isStreaming && (
            <button
              type="submit"
              data-onboarding="chat-send-button"
              disabled={!inputText.trim()}
              className={`absolute bottom-[10px] right-[10px] w-8 h-8 rounded-xl flex items-center justify-center transition-all duration-100 ${
                !inputText.trim()
                  ? 'bg-gray-300 dark:bg-gray-600 text-gray-500 dark:text-gray-400 cursor-not-allowed'
                  : 'bg-blue-500 hover:bg-blue-600 text-white'
              }`}
              title={!inputText.trim() ? "Type a message to send" : "Send message"}
            >
              {isLLMSettingsLoading ? (
                <svg className="animate-spin h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
              ) : (
                <HiOutlinePaperAirplane className="w-3.5 h-3.5" />
              )}
            </button>
          )}
        </form>
      </div>
    </DelayedFadeIn>
  );
}

export default NewChatMentionTextArea;